import React from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

function PhasedProjectComponent({ dataTrackerPhaseDetails, getStatusColor }) {
  

  return (
    <>
      <div className='phased-component-border'>
        <Tabs  type='card' size='small'
        destroyInactiveTabPane
        >
          {dataTrackerPhaseDetails?.map((everyPhase, index) => {
            return (
              <TabPane tab={`P${index + 1}`} key={`${everyPhase.phase}`}>
                <div className='phase-info-container'>
                  <div className='section-container'>
                    <div className='new-container'>
                      <b>Location Sheet Status:</b>
                    </div>
                    <span
                      style={{
                        color: getStatusColor[everyPhase.locSheetDue],
                      }}
                      className='status-font'
                    >
                      {everyPhase.locSheetStatus}
                    </span>
                  </div>
                  <div className='section-container'>
                    <div className='new-container'>
                      <b>SE Assets Status:</b>
                    </div>
                    <span
                      style={{ color: getStatusColor[everyPhase.seAssetsDue] }}
                      className='status-font'
                    >
                      {everyPhase.seAssetsStatus}
                    </span>
                  </div>

                  <div className='section-container'>
                    <div className='new-container'>
                      <b>PCE Assets Status:</b>
                    </div>
                    <span
                      style={{ color: getStatusColor[everyPhase.pceAssetsDue] }}
                      className='status-font'
                    >
                      {everyPhase.pceAssetsStatus}
                    </span>
                  </div>
                  {/* <br /> */}
                  {/* <div className='section-container'>
                    <div className='new-container'>
                      <b>Assets Expected </b>
                    </div>
                    <span className='status-font'>
                      {everyPhase.expectedAssetCnt}
                    </span>
                  </div> */}
                   <div>
                  <b style={{fontSize:'12px'}}>{`Total No. of Assets Expected Phase ${index+1}:`} </b>
                    <span style={{ fontSize: '12px' }}>{everyPhase.expectedAssetCnt}</span>
                </div>
                </div>
              </TabPane>
            );
          })}
        </Tabs>
      </div>
    </>
  );
}

export default PhasedProjectComponent;
